'use client';
import { getAgencyConfig } from './agency-config-helper';
import * as formStyles from './styles/formStyles';

interface IntroFormProps {
  onSubmit: () => void;
  dictionary: any;
  disableSubmit?: boolean;
  agencyId?: string;
}

export function IntroForm({ onSubmit, dictionary, disableSubmit = false, agencyId }: IntroFormProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit();
  };

  const agencyConfig = agencyId ? getAgencyConfig(agencyId) : null;
  const startingMessageKey = agencyConfig?.startingMessageOverrideKey || 'startingMessage';
  const startingMessage = dictionary?.sellingForm?.[startingMessageKey] || dictionary?.sellingForm?.startingMessage;

  return (
    <div className="w-full">
      <p className="text-base text-zinc-800">
        {startingMessage}
      </p>
      
      <form onSubmit={handleSubmit}>
        <button
          type="submit"
          disabled={disableSubmit}
          className={`${formStyles.submitButtonBaseClasses} ${
            disableSubmit ? formStyles.submitButtonDisabledClasses : formStyles.submitButtonHoverClasses
          }`}
        >
          {dictionary?.sellingForm?.readyResponse}
        </button>
      </form>
    </div>
  );
}